import { Empty, Typography } from 'antd';
import { type IMapGroup } from '../../layers/MapGroup.ts';
import { type IMapLayer } from '../../layers/MapLayer.ts';
import { MapLayersTreeInput } from '../../layers/tree/MapLayersTreeInput.tsx';

export interface ILayerCatalogPreviewProps {
  groups: IMapGroup[];
  layers: IMapLayer[];
  /** Nome del campo di form che contiene le chiavi spuntate. */
  name: string;
}

/** Titolo della foglia layer nell'anteprima: nome + tipo del layer. */
function renderCatalogLayerTitle(layer: IMapLayer) {
  return (
    <>
      {layer.name}{' '}
      <Typography.Text type="secondary">({layer.type})</Typography.Text>
    </>
  );
}

/**
 * Anteprima selezionabile ad albero dei livelli e gruppi di un catalogo.
 * Riusa {@link MapLayersTreeInput} mostrando il tipo di ogni layer e il
 * conteggio dei livelli per gruppo; la selezione è un campo di form.
 */
export function LayerCatalogPreview(props: ILayerCatalogPreviewProps) {
  const { groups, layers, name } = props;

  if (groups.length === 0 && layers.length === 0) {
    return <Empty description="Nessun livello o gruppo nel catalogo" />;
  }

  return (
    <div>
      <Typography.Text strong>Anteprima</Typography.Text>
      <MapLayersTreeInput
        name={name}
        groups={groups}
        layers={layers}
        defaultExpandAll
        showCounts
        renderLayerTitle={renderCatalogLayerTitle}
        style={{ marginTop: 8, maxHeight: 300, overflow: 'auto' }}
      />
    </div>
  );
}
